import { CivilStatus } from "../shared/enums/CivilStatus";

export class Personal {
    rg: string;
    cpf: string;
    born: string;
    sex: Number = 0;
    civilStatus: CivilStatus = 0;
    motherName: string;
    fatherName: string;
    homePhone: string;
    cellPhone: string;
    cep: string;
    address: string;
    number: string;
    complement: string;
    district: string;
    city: string;
    state: string = "";


    loadToEdit(r: any) {
        this.rg = r.rg;
        this.cpf = r.cpf;
        this.born = r.born;
        this.sex = r.sex;
        this.civilStatus = r.civilStatus;
        this.motherName = r.motherName;
        this.fatherName = r.fatherName;
        this.homePhone = r.homePhone;
        this.cellPhone = r.cellPhone;
        this.cep = r.cep;
        this.address = r.address;
        this.number = r.number;
        this.complement = r.complement;
        this.district = r.district;
        this.city = r.city;
        this.state = r.state;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Personal.model.ts